import { UrlParamKey, getUrlParamByKey } from '@/utils/url-params-helper';
import { onMounted, ref } from 'vue';
// 2025-06-01 的士推广活动
const ACT_MODULE_NAME = 'promoter2506';
const TARGET_PROMOTER_SPID = 'SZBUS';

const getPromoterParams = () => {
  const spId = getUrlParamByKey(UrlParamKey.spId);
  const promoterActId = spId === TARGET_PROMOTER_SPID ? spId : '';
  const promoterCode = getUrlParamByKey(UrlParamKey.mtn) || getUrlParamByKey(UrlParamKey.MTN);
  return { promoterActId, promoterCode };
};

export const usePromoterAct = () => {
  const { promoterActId, promoterCode } = getPromoterParams();
  const disSource = ref('');
  const isInit = ref(false);
  const promoterInfo = ref({
    isPromoterAct: false,
    promoterCode,
  });

  onMounted(async () => {
    /** 非推广员场景不需要初始化 */
    if (!promoterActId) {
      isInit.value = true;
      return;
    }
    promoterInfo.value = {
      ...promoterInfo.value,
      isPromoterAct: !!promoterInfo.value.promoterCode,
    };
    // 是推广员场景，才赋值disSource
    disSource.value = promoterInfo.value.isPromoterAct ? getDisSource() : '';
    isInit.value = true;
  });

  const getDisSource = () => [ACT_MODULE_NAME, promoterActId, promoterCode].join('.');


  return {
    disSource,
    isInit,
    promoterInfo,
  };
};
